[
  { "path": "/how-it-works", "labelKey": "landing.howItWorksNav" },
  { "path": "/privacy", "labelKey": "footer.privacy" },
  { "path": "/terms", "labelKey": "footer.terms" },
  { "path": "/contact", "labelKey": "footer.contact" }
]
